import React, { useContext, useState } from 'react'
import BigModal from '../../../../../../components/Modals/BigModal'
import { Box, Button, Checkbox, Grid, Stack, Typography } from '@mui/material'
import SmallModal from '../../../../../../components/Modals/SmallModal'

const LaryngospasmActions = ({ open, onClose, submitModule }) => {
  const [checklistOptions, setCheckListOptions] = useState({
    'Stop Procedure': false,
    'Suction Secretions if Present': false,
    'Apply O2 with via BVM with PEEP': false,
    'Use 2-Person BVM Ventilation': false,
    'If no improvement, deepen sedation': false,
  })

  const helperTexts = {
    'If no improvement, deepen sedation': 'further 0.5mg/kg dose',
  }

  return (
    <SmallModal
      open={open}
      onClose={onClose}
      style={{ width: '400px', maxWidth: '80vw' }}
    >
      <Stack overflow="auto">
        <Typography variant="title2">Laryngospasm Actions</Typography>
        {[
          Object.keys(checklistOptions).map((option, index) => (
            <Stack
              key={index}
              marginY={0.5}
              direction="row"
              alignItems="center"
              onClick={(e) =>
                setCheckListOptions((prev) => ({
                  ...prev,
                  [option]: !prev[option],
                }))
              }
              sx={{ cursor: 'pointer' }}
            >
              <Checkbox checked={!!checklistOptions[option]} />
              <Stack>
                <Typography>{option}</Typography>
                {helperTexts[option] && (
                  <Typography variant="caption">
                    {helperTexts[option]}
                  </Typography>
                )}
              </Stack>
            </Stack>
          )),
        ]}
        <Grid xs={12} container spacing={1}>
          <Grid item xs={12} lg={4}>
            <Button
              color="error"
              onClick={() => onClose()}
              variant="contained"
              fullWidth
            >
              Cancel
            </Button>
          </Grid>
          <Grid item xs={12} lg={8}>
            <Button
              color="success"
              onClick={() => {
                submitModule('Laryngospasm Actions (Post Sedation)', {
                  ...checklistOptions,
                  isChecklist: true,
                })
                onClose()
              }}
              variant="contained"
              fullWidth
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </SmallModal>
  )
}

export default LaryngospasmActions
